const DDD_CODES = [
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48,
  49, 51, 53, 54, 55, 61, 62, 64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99
]
const BRAZIL_COUNTRY_CODE = '+55'
const VALID_INITIAL_NUMBERS_OF_LANDLINE = [2, 3, 4, 5, 7]

/**
 * Validates a Brazilian phone number.
 *
 * This function checks if a given phone number is valid according to Brazilian rules.
 * It supports both cellphones and landlines and can handle numbers with or without the country code (`+55`).
 *
 * @param phone - The phone number to validate. It can include the country code (`+55`) or not,
 *                         and may contain non-numeric characters (e.g., spaces, parentheses, or dashes).
 * @returns `true` if the phone number is valid, `false` otherwise.
 *
 * @example
 * isValidPhoneNumber("+5511998765432"); // true
 * isValidPhoneNumber("11998765432");   // true
 * isValidPhoneNumber("21987654321");   // true
 * isValidPhoneNumber("55123456789");   // false (missing country code or invalid format)
 * isValidPhoneNumber("123456789");     // false (invalid DDD code)
 */
export function isValidPhoneNumber(phone: string) {
  const phoneNumber = (() => {
    let _phoneNumber = phone

    if (_phoneNumber.startsWith(BRAZIL_COUNTRY_CODE)) {
      _phoneNumber = _phoneNumber.replace(BRAZIL_COUNTRY_CODE, '')
    }

    return _phoneNumber.replace(/\D/g, '')
  })()

  const isLandline = phoneNumber.length === 10
  const isCell = phoneNumber.length === 11

  if (!(isCell || isLandline)) return false

  if (isCell && Number(phoneNumber.substring(2, 3)) !== 9) return false

  if (/^(\d)\1{9,10}/g.test(phoneNumber)) return false

  if (!DDD_CODES.includes(Number(phoneNumber.substring(0, 2)))) return false

  if (isLandline && !VALID_INITIAL_NUMBERS_OF_LANDLINE.includes(Number(phoneNumber.substring(2, 3)))) return false

  return true
}
